import { render } from "./BrownTree.vue?vue&type=template&id=0a963d78&scoped=true"
import script from "./BrownTree.vue?vue&type=script&lang=js"
export * from "./BrownTree.vue?vue&type=script&lang=js"

import "./BrownTree.vue?vue&type=style&index=0&id=0a963d78&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a963d78"]])

export default __exports__